import React, { useEffect } from 'react';
import { componentMap } from './compMapping';
import './serverDrivenUICss.css';

export default function Checkbox({ details, setValues = () => {}, inputKey }) {
  const selectOption = (option) => {
    var checkboxes = document.getElementsByName(inputKey);
    checkboxes.forEach((item) => {
      if (item.id !== option) item.checked = false;
      else {
        setValues((prevState) => {
          if (inputKey) return { ...prevState, [inputKey]: option };
          else return { ...prevState };
        });
        item.checked = true;
      }
    });
  };

  useEffect(() => {
    details?.options.forEach((option) => {
      if (option?.selected) selectOption(option.slug);
    });
  }, [details]);
  return (
    <div
      css={`
        background: ${details?.bg_color};
        padding: ${details?.padding || '1rem'};
        border-radius: ${details?.border_radius || '5px'};
        display: flex;
        flex-direction: ${details?.orientation === 'vertical'
          ? 'column'
          : 'row'};
        gap: ${details?.gap || '0.5rem'};
        width: ${details?.width || '100%'};
      `}
    >
      <div className='tw-flex-col tw-gap-3 tw-w-full'>
        {details?.options.map((option, index) => {
          return (
            <>
              <div
                className='round tw-w-full tw-flex tw-items-start tw-justify-start tw-gap-2'
                css={`
                  & label {
                    padding: 0.7rem !important;
                  }
                `}
                onClick={() => {
                  selectOption(option.slug);
                }}
              >
                <span className='tw-flex tw-items-center tw-justify-center'>
                  <input
                    type='checkbox'
                    name={inputKey}
                    id={option.slug}
                    defaultChecked={option?.selected}
                  />
                  <label htmlFor={option.slug}></label>
                </span>
                <span className='tw-flex tw-items-center tw-justify-center'>
                  <div className='tw-flex-col'>
                    {option?.children.length > 0 &&
                      option?.children.map((child) => {
                        let CompName = '';
                        if (child.type in componentMap)
                          CompName = componentMap[`${child.type}`];
                        else return null;
                        return <CompName details={child} />;
                      })}
                  </div>
                </span>
              </div>
              {index < details?.options?.length - 1 && (
                <hr
                  color='#e5f3f3'
                  css={`
                    height: 0px;
                    margin: 0.1rem;
                  `}
                />
              )}
            </>
          );
        })}
      </div>
    </div>
  );
}
